import CopyTextBlock from 'components/Basic/CopyTextBlock/CopyTextBlock';
import { isWithErrorDebugging } from 'helpers/errors/isWithErrorDebugging';
import { isClient } from 'helpers/isServer';
import { toast, ToastOptions } from 'react-toastify';
import { GtmMessageOriginType } from 'types/gtm';
import { getGtmMessageEvent } from 'utils/Gtm/EventFactories';
import { gtmSafePushEvent } from 'utils/Gtm/Gtm';

const showMessage = (message: string, type: 'error' | 'info' | 'warning' | 'success', options?: ToastOptions): void => {
    const messageOptions: ToastOptions = {
        toastId: message,
        ...options,
    };

    if (toast.isActive(message)) {
        return;
    }

    if (type === 'error') {
        if (isWithErrorDebugging) {
            toast.error(() => <CopyTextBlock textToCopy={message} />, {
                toastId: message,
                autoClose: false,
                closeOnClick: false,
                style: { width: '100%' },
            });
        } else {
            toast.error(
                () => <span dangerouslySetInnerHTML={{ __html: message }} data-testid="toast-error" />,
                messageOptions,
            );
        }
    }
    if (type === 'info') {
        toast.info(
            () => <span dangerouslySetInnerHTML={{ __html: message }} data-testid="toast-info" />,
            messageOptions,
        );
    }
    if (type === 'warning') {
        toast.warning(
            () => <span dangerouslySetInnerHTML={{ __html: message }} data-testid="toast-warning" />,
            messageOptions,
        );
    }
    if (type === 'success') {
        toast.success(
            () => <span dangerouslySetInnerHTML={{ __html: message }} data-testid="toast-success" />,
            messageOptions,
        );
    }
};

export const showErrorMessage = (message: string, origin?: GtmMessageOriginType): void => {
    if (isClient) {
        showMessage(message, 'error');
        const event = getGtmMessageEvent('error', message, 'flash message', origin);
        gtmSafePushEvent(event);
    }
};
export const showInfoMessage = (message: string, origin?: GtmMessageOriginType, options?: ToastOptions): void => {
    if (isClient) {
        showMessage(message, 'info', options);
        const event = getGtmMessageEvent('information', message, 'flash message', origin);
        gtmSafePushEvent(event);
    }
};
export const showWarningMessage = (message: string): void => {
    if (isClient) {
        showMessage(message, 'warning');
    }
};
export const showSuccessMessage = (message: string): void => {
    if (isClient) {
        showMessage(message, 'success');
    }
};
